// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// ✅ Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyATev4mIRlK2ERVSpMOla4JPW5mYdTarr8",
  authDomain: "cbseresources-f6421.firebaseapp.com",
  projectId: "cbseresources-f6421",
  storageBucket: "cbseresources-f6421.appspot.com",
  messagingSenderId: "596874984577",
  appId: "1:596874984577:web:f9908c1e25131e00cba180",
  measurementId: "G-R5SBSKVPC4"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Export Firestore & Auth
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
